import { useQuery } from '@gogame/query';

import { loadInfluencerCampaignDetails } from 'scenes/Influencers/InfluencersCampaigns/sources/influencersCampaigns';

import { details } from './queryKeyFactory';

export const useLoadInfluencerCampaignDetails = (id) => {
  return useQuery(
    details(id),
    (_, { signal }) => loadInfluencerCampaignDetails({ id }, { signal }),
    {
      enabled: true,
    }
  );
};
